import React from 'react';

function HamburgerCloseIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg 
      width="32" 
      height="33" 
      viewBox="0 0 32 33" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24 8.49722L8 24.4972M8 8.49722L24 24.4972" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
}

export default HamburgerCloseIcon;
